import { toast } from "react-toastify";
import config from '../../Config/config.json';
import { LogOut, changeLoations } from "../../Redux/Actions/index.js";
import { store } from "../../Redux/Store/index.js";
import { EquipamentRequests } from "./request.ts";
import i18n from "../../Config/i18n.js";
import { EquipamentServices } from "./index.js";
import { handleError } from "../../util/errorHandler.js";

/**
 * Classe para gerenciamento da página de equipamentos
 */
export class GroupServices {
    constructor() {
        this.equipamentRequests = new EquipamentRequests();
        this.equipamentServices = new EquipamentServices();
    }

    // Busca lista de grupos de equipamentos
    async getAllGroups(search, page){
        try {
            const response = await this.equipamentRequests.getAllGroups(search, page);
            return response;
        } catch (error) {
            toast(error.message, {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            if(error.status === 401){
                store.dispatch(LogOut());
            }
            return false;
        }
    }

    // Busca um grupo de equipamentos
    async getGroup(id){
        try {
            const response = await this.equipamentRequests.getGroup(id);
            return response;
        } catch (error) {
            handleError(error, { theme: config.theme });
            return false;
        }
    }

    // Edita um grupo de equipamentos
    async editGroup (id, data){
        try {
            const response = await this.equipamentRequests.editGroup(id, data);
            toast(i18n.t('message.group-service.edit-group'), {
                position: "top-center",
                type: 'success',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            return response;
        } catch (error) {
            handleError(error, { theme: config.theme });
            return false;
        }
    }

    // Busca todos equipamentos
    async getAllEquipaments(search){
        try {
            const response = await this.equipamentRequests.getAllEquipaments(search);
            return response;
        } catch (error) {
            handleError(error, { theme: config.theme });
            return [];
        }
    }

    // Cria um novo grupo
    async SaveGroup (data){
        try {
            const response = await this.equipamentRequests.createGroup(data);
            toast(i18n.t('message.group-service.save-group'), {
                position: "top-center",
                type: 'success',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            return response;
        } catch (error) {
            handleError(error, { theme: config.theme });
            return false;
        }
    }

    // Busca alocações que o usuário pode ver
    async getLocations(){
        try {
            const response = await this.equipamentRequests.getlocations();
            this.locations = response;
            return response;
        } catch (error) {
            handleError(error, { theme: config.theme });
            return false;
        }
    }

    // Muda o tipo de alocações sendo exibido
    ChangeLocationType(type){
        store.dispatch(changeLoations(this.locations[type]));
    }

    // Busca estados
    async getStates(){
        try {
            const response = await this.equipamentRequests.getStates();
            return response;
        } catch (error) {
            handleError(error, { theme: config.theme });
            return [];
        }
    }

    // Busca cidades
    async getCities(state){
        try {
            const response = await this.equipamentRequests.getCities(state);
            return response;
        } catch (error) {
            handleError(error, { theme: config.theme });
            return [];
        }
    }

    // Busca equipamentos autorizados
    async getAuthorizedEquipaments(){
        try {
            const response = await this.equipamentRequests.getAuthorizedEquipaments();
            return response.authorized_equipments;
        } catch (error) {
            handleError(error, { theme: config.theme });
            return [];
        }
    }

    // adiciona um equipamento a um grupo
    async addEquipamentToGroup(idGroup, idEquipment){
        try {
            const response = await this.equipamentRequests.addEquipamentToGroup(idGroup, idEquipment);
            toast(i18n.t('message.group-service.add-equipament-to-group'), {
                position: "top-center",
                type: 'success',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            return response;
        } catch (error) {
            handleError(error, { theme: config.theme });
            return false;
        }
    }

    // remove um equipamento de um grupo
    async removeEquipamentFromGroup(idGroup, idEquipment){
        try {
            const response = await this.equipamentRequests.removeEquipamentFromGroup(idGroup, idEquipment);
            toast(i18n.t('message.group-service.remove-equipament-from-group'), {
                position: "top-center",
                type: 'success',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            return response;
        } catch (error) {
            handleError(error, { theme: config.theme });
            return false;
        }
    }

    async deleteGroup(id, navigate){
        try {
            const response = await this.equipamentRequests.deleteGroup(id);
                toast(i18n.t('message.group-service.delete-group'), {
                position: "top-center",
                type: 'success',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            navigate('/adm/grupos');
            return response;
        } catch (error) {
            handleError(error, { theme: config.theme });
            return false;
        }
    }

    // Inicia o mapa com as coordenadas do equipamento
    async startMap(mapContainer, latitude, longitude, id, name, type) {
        return this.equipamentServices.startMap(mapContainer, latitude, longitude, id, name, type);
    }

    // Redimensiona o mapa
    resizeMap() {
        return this.equipamentServices.resizeMap();
    }

    async getAreasAndLines(id) {
        return this.equipamentServices.getAreasAndLines(id);
    }

    setClickType(type) {
        return this.equipamentServices.setClickType(type);
    }

    // desfaz a última ação realizada no mapa
    undo(){
        return this.equipamentServices.undo();
    }

    // refaz a última ação desfeita no mapa
    redo(){
        return this.equipamentServices.redo();
    }

    // busca areas relacionadas ao grupos
    async getAreas(id) {
        try {
            const response = await this.equipamentRequests.getAreas(id);
            this.equipamentServices.areas = response.areas;
            this.equipamentServices.loadAreas();
            return response.areas;
        } catch (error) {
            handleError(error, { theme: config.theme });
        }
    }

    async getAllAreas(){
        return this.equipamentServices.getAllAreas();
    }

    // salva a localizações no banco de dados
    async saveLocations(groupId, areaName) {
        if (this.equipamentServices.areaId){
            let currentAreas = JSON.parse(JSON.stringify(this.equipamentServices.currentArea));
            currentAreas.push(currentAreas[0]);
            let form = {
                points: currentAreas,
            }
            try {
                const response = await this.equipamentRequests.editArea(this.equipamentServices.areaId, form);
                toast(response.message, {
                    position: "top-center",
                    type: 'success',
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                    theme: config.theme,
                });
            } catch (error) {
                handleError(error, { theme: config.theme });
            }
        }else if (this.equipamentServices.currentArea.length > 2) {
            try {
                let currentAreas = JSON.parse(JSON.stringify(this.equipamentServices.currentArea));
                currentAreas.push(currentAreas[0]);
                let savedArea = {
                    "name": areaName || "Area",
                    "description": i18n.t('message.group-service.area-description', { id: groupId }),
                    "points": currentAreas,
                }
                const response = await this.equipamentRequests.saveArea(savedArea);
                this.areaId = response[0].id;
                await this.equipamentRequests.linkEquipamentToArea(groupId, response[0].id);
                toast(response.message, {
                    position: "top-center",
                    type: 'success',
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                    theme: config.theme,
                });
            } catch (error) {
                handleError(error, { theme: config.theme });
            }
        }

        if(this.equipamentServices.newCoords){
            let form = new FormData();
            form.append('latitude', this.equipamentServices.newCoords.lat)
            form.append('longitude', this.equipamentServices.newCoords.lng)
            form.append('_method', 'PATCH');
            const group = await this.editGroup(groupId, form);
            return group;
        }
    }

    // adiciona uma nova área ao grupo
    async addArea(groupId, areaId) {
        try {
            const response = await this.equipamentRequests.linkEquipamentToArea(groupId, areaId);
            toast(response.message, {
                position: "top-center",
                type: 'success',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            this.getAreas(groupId)
            return true;
        } catch (error) {
            handleError(error, { theme: config.theme });
            return false;
        }
    }

    // remover area do mapa e desvincula do grupo
    async removeArea(groupId, areaId) {
        try {
            const response = await this.equipamentRequests.removeLinkEquipamentFromArea(groupId, areaId);
            toast(response.message, {
                position: "top-center",
                type: 'success',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: config.theme,
            });
            this.areas = this.equipamentServices.areas.filter(area => area.id !== areaId);
            this.equipamentServices.loadAreas();
            return true;
        } catch (error) {
            handleError(error, { theme: config.theme });
            return false;
        }
    }
}